const button = '<div class="nav__template__arrow"><img src="http://dev.magiauslug.pl/testa/wp-content/themes/testa/img/svg/arrowRight.svg" alt=""></div>';

const showMenu = (item) => {
    if (item.classList.contains('menu-item-has-children')) {
        var ul = item.querySelector('ul.sub-menu')
        ul.style.display = 'block';
    }
}
const hideMenu = (item) => {
    if (item.classList.contains('menu-item-has-children')) {
        var ul = item.querySelector('ul.sub-menu')
        ul.style.display = 'none';
    }
}
// const customitems = document.querySelectorAll('.menu-item')
// customitems.forEach(custom => {
//     custom.addEventListener('mouseover', () => {
//         if (window.innerWidth > 768) {
//             console.log(custom)
//             var id = custom.getAttribute('class');
//             id = id.split(' ')
//             id = id[id.length - 1].split('-')
//             id = id[id.length - 1]
//             if (document.querySelector('.nav__images .nav__image[data-nav-image="' + id + '"]')) {
//                 var image = document.querySelector('.nav__images .nav__image[data-nav-image="' + id + '"]')
//                 image.classList.add('nav__image--active')
//             } else {
//                 if (document.querySelector('.nav__images .nav__image--active')) {
//                     var image = document.querySelector('.nav__images .nav__image--active')
//                     image.classList.remove('nav__image--active')
//                 }
//             }
//         }
//     })
// })

const backButton = document.querySelector('.nav__back')
const firstItems = document.querySelectorAll('.nav>ul>li')
var firstPreviousItem = false;
firstItems.forEach(item => {

    item.addEventListener('mouseover', () => {
        if (window.innerWidth > 768) {
            if (firstPreviousItem) {
                hideMenu(firstPreviousItem)
            }
            showMenu(item)
            firstPreviousItem = item;

        }
    })
    if (item.classList.contains('menu-item-has-children')) {
        item.innerHTML = item.innerHTML + button;
        var next = item.querySelector('.nav__template__arrow')
        next.addEventListener('click', () => {
            if (firstPreviousItem) {
                hideMenu(firstPreviousItem)
            }
            showMenu(item)
            firstPreviousItem = item;
            backButton.classList.add('nav__back--visible')
        })
    }
})


const nextItems = document.querySelectorAll('.nav>ul>li>.sub-menu>li.menu-item-has-children')
var previousNextItem = false;
nextItems.forEach(item => {

    item.addEventListener('mouseover', () => {
        if (previousNextItem) {
            hideMenu(previousNextItem)
        }
        showMenu(item)
        previousNextItem = item;

    })
    item.innerHTML = item.innerHTML + button;
    var next = item.querySelector('.nav__template__arrow')
    next.addEventListener('click', () => {
        if (previousNextItem) {
            hideMenu(previousNextItem)
        }
        showMenu(item)
        previousNextItem = item;
    })
})


const lastItems = document.querySelectorAll('.nav>ul>li>.sub-menu>li.menu-item-has-children>.sub-menu>li.menu-item-has-children')
var previouslastItem = false;
lastItems.forEach(item => {
    item.addEventListener('mouseover', () => {
        if (previouslastItem) {
            hideMenu(previouslastItem)
        }
        showMenu(item)
        previouslastItem = item;

    })
    item.innerHTML = item.innerHTML + button;
    var next = item.querySelector('.nav__template__arrow')
    next.addEventListener('click', () => {
        if (previouslastItem) {
            hideMenu(previouslastItem)
        }
        showMenu(item)
        previouslastItem = item;
    })
})

const menuButton = document.querySelector('.header__button')
const nav = document.querySelector('.nav')
const header = document.querySelector('.header') 
const toggleMenu = () => {
    if (document.querySelector('header').classList.contains('header__portfolio')) {
        if (nav.classList.contains('nav--open')) {
            document.querySelector('body').setAttribute('data-nav', 'dark')
        } else {
            document.querySelector('body').setAttribute('data-nav', '')
        }
    }
    header.classList.toggle('header--open')
    nav.classList.toggle('nav--open')
    if (previouslastItem) {
        hideMenu(previouslastItem)
    }
    if (previousNextItem) {
        hideMenu(previousNextItem)
    }
    if (firstPreviousItem) {
        hideMenu(firstPreviousItem)
    }
}

menuButton.addEventListener('click', () => {
    toggleMenu()
})

const main = document.querySelector('main')
main.addEventListener('click', () => {
    nav.classList.remove('nav--open')
    if (previouslastItem) {
        hideMenu(previouslastItem)
    }
    if (previousNextItem) {
        hideMenu(previousNextItem)
    }
    if (firstPreviousItem) {
        hideMenu(firstPreviousItem)
    }
})

backButton.addEventListener('click', () => {
    if (previouslastItem) {
        hideMenu(previouslastItem)
        previouslastItem = null
    } else {
        if (previousNextItem) {
            hideMenu(previousNextItem)
            previousNextItem = null
        } else {
            if (firstPreviousItem) {
                hideMenu(firstPreviousItem)
                backButton.classList.remove('nav__back--visible')
            }
        }
    }
})